<app-header
  icon="fas fa-cog"
  text="Allgemeines"
  sub="Definieren Sie die Grundeinstellungen Ihres Atlas."></app-header>
<p-divider />
<form *ngIf="form" [formGroup]="form" (ngSubmit)="submit()" class="p-fluid">
  <app-header icon="fas fa-image" text="Logo" />
  <div class="flex gap-5 align-items-end">
    @if (activeCommune?.atlasConfig?.logo; as logo) {
      <div class="p-card p-2">
        <app-logo hStyleClass="h-10rem w-14rem" [logoFileName]="logo" />
      </div>
    } @else {
      <div
        class="surface-ground p-card text-5xl flex align-items-center justify-content-center h-8rem w-12rem">
        <i class="fas fa-image"></i>
      </div>
    }

    <p-fileUpload
      mode="basic"
      chooseLabel="Bild auswählen"
      chooseIcon="pi pi-upload"
      name="logo"
      [url]="communeService.getLogoUploadUrl()"
      [auto]="true"
      accept="image/*"
      maxFileSize="1000000"
      (onUpload)="onUpload($event)" />
  </div>
  <p-divider />

  <app-header icon="fas fa-cog" text="Dezimalstellen" />
  <div class="grid">
    <div class="col-6">
      <div class="grid">
        <app-form-field-wrapper
          [label]="'absolut'"
          [name]="'absoluteDecimals'"
          [colSize]="2">
          <p-inputNumber
            id="absoluteDecimals"
            type="number"
            formControlName="absoluteDecimals"></p-inputNumber>
        </app-form-field-wrapper>
        <app-form-field-wrapper
          [label]="'relativ'"
          [name]="'relativeDecimals'"
          [colSize]="2">
          <p-inputNumber
            id="relativeDecimals"
            type="number"
            formControlName="relativeDecimals"></p-inputNumber>
        </app-form-field-wrapper>
      </div>
    </div>
  </div>
  <app-header icon="fas fa-palette" text="Farben"></app-header>
  <div class="grid">
    <app-colorset-dropdown
      [colSize]="5"
      formControlName="colorset"></app-colorset-dropdown>
  </div>
</form>
